import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { injectIframeAnchorGuards } from "../../lib/iframeAnchorGuards";

export const Route = createFileRoute("/love/$slug")({
  component: WeddingSitePage,
});

function WeddingSitePage() {
  const { slug } = Route.useParams();
  const site = useQuery(api.weddingSites.getBySlug, { slug });

  if (site === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center space-y-2">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent-soft)] border-t-[var(--color-accent)]"></div>
          <p className="text-gray-500 text-sm">Cargando...</p>
        </div>
      </div>
    );
  }

  if (site === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center space-y-2">
          <p className="text-4xl">💍</p>
          <h1 className="text-xl font-semibold text-gray-800">
            Invitación no encontrada
          </h1>
          <p className="text-gray-500 text-sm">
            Esta invitación no existe o aún se está generando.
          </p>
        </div>
      </div>
    );
  }

  if (site.status === "generating" || !site.generatedHtml) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center space-y-2">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent-soft)] border-t-[var(--color-accent)]"></div>
          <p className="text-gray-500 text-sm">Generando invitación...</p>
        </div>
      </div>
    );
  }

  // Render the pre-generated HTML in an iframe for full isolation
  return (
    <iframe
      sandbox="allow-scripts allow-forms allow-popups"
      srcDoc={injectIframeAnchorGuards(site.generatedHtml, {
        blockNonAnchorLinks: false,
        preventForms: false,
      })}
      style={{ border: "none", height: "100vh", width: "100%" }}
      title={`Boda de ${site.brideName} & ${site.groomName}`}
    />
  );
}
